import React, { useEffect, useState } from 'react';

const KEY = 'padaid_analytics_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(KEY);
      if (v === null) setVisible(true);
    } catch (e) { setVisible(true); }
  }, []);

  if (!visible) return null;

  const accept = () => { try { localStorage.setItem(KEY, 'true'); } catch(e){} setVisible(false); };
  const decline = () => { try { localStorage.setItem(KEY, 'false'); } catch(e){} setVisible(false); };

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 p-4">
      <div className="max-w-5xl mx-auto bg-card border border-border rounded-lg shadow-lg p-4 flex flex-col sm:flex-row items-center gap-3">
        <p className="text-sm text-muted-foreground flex-1">
          Nous utilisons des cookies pour mesurer l'audience (pages vues) et améliorer l'expérience. Vous pouvez accepter ou refuser.
        </p>
        <div className="flex gap-2">
          <button onClick={decline} className="px-3 py-2 rounded-md border border-border text-sm">Refuser</button>
          <button onClick={accept} className="px-3 py-2 rounded-md bg-primary text-primary-foreground text-sm">Accepter</button>
        </div>
      </div>
    </div>
  );
};

export const hasConsent = () => {
  try { return localStorage.getItem(KEY) === 'true'; } catch(e){ return false; }
};

export default CookieConsent;